import { Reducer, combineReducers } from 'redux';

import geoLocationReducer from './GeoLocation';
import measurementsReducers from '../../../apps/measurements/reducers';

import { websiteApi } from '../slices/WebsiteApi';
import { opzetApi } from '../slices/OpzetApi';
import { geolocationApi } from '../slices/GeolocationApi';
import { heatApi } from '../../../apps/registration-desk/store/slices/HeatApi';
import { containerApi } from '../../../apps/container-locations/store/slices/ContainerApi';

const rootReducer = combineReducers({
  geolocation: geoLocationReducer,
  measurements: measurementsReducers as Reducer<any, any>,
  [websiteApi.reducerPath]: websiteApi.reducer,
  [opzetApi.reducerPath]: opzetApi.reducer,
  [geolocationApi.reducerPath]: geolocationApi.reducer,
  [heatApi.reducerPath]: heatApi.reducer,
  [containerApi.reducerPath]: containerApi.reducer,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
